import { SvgIcon, SvgIconOwnProps } from "@mui/material"
import { FC } from "react"

export const Parcel: FC<{} & SvgIconOwnProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.148833 3.60268L1.41539 0.824379C1.48327 0.675427 1.62339 0.585327 1.78706 0.585327H10.2124C10.3761 0.585327 10.5161 0.675326 10.584 0.824379L11.8507 3.60268H0.148833ZM11.9999 4.25621H0V12.1768C0 12.4019 0.183444 12.5853 0.408499 12.5853H11.5915C11.8165 12.5853 12 12.4019 12 12.1768L11.9999 4.25621Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  )
}
